"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logout = exports.authorize = void 0;
/**
 * @deprecated This method is deprecated and must be removed
 */
function authorize() {
    console.error('This method is deprecated and must be removed');
    return Promise.resolve();
}
exports.authorize = authorize;
/**
 * @deprecated This method is deprecated and must be removed
 */
function logout() {
    console.error('This method is deprecated and must be removed');
    return Promise.resolve();
}
exports.logout = logout;
//# sourceMappingURL=authorization.js.map